const NANO_IN_GRAM = 1e9;

/** Formats a nanoGRAM amount for display, e.g. 25000000000000n → "25 000". */
export function formatGram(nano: bigint | null | undefined, maxFractionDigits = 2): string {
    if (nano === null || nano === undefined) return "--";

    return (Number(nano) / NANO_IN_GRAM).toLocaleString("ru-RU", {
        maximumFractionDigits: maxFractionDigits,
    });
}
